<script lang="ts">
	import { onMount } from "svelte";
	import FormControl from "../form-control/FormControl.svelte";
	import Input from "../input/Input.svelte";
	import InputPasswordToggle from "./InputPasswordToggle.svelte";

	export let value: string | number | null = "";
	export let placeholder: string = "";
	export let debounce = 0;
	export let type: string = "";
	export let borderless = false;
	export let ref: any = "";
	export let name = "";
	export let required = false;
	export let minLength: number | null = null;
	export let helperTextWhiteSpace: boolean = true;

	//formControl props
	export let label: string = "";
	export let helperText: string = "";
	export let error: string | string[] | null = "";
	export let warning: string | string[] | null = "";
	export let icon: string = "";

	export let focused = false;
	let isPassword: boolean = false;
	let invalid = false;
	onMount(() => {
		isPassword = type === "password";
	});
</script>

<FormControl
	{helperTextWhiteSpace}
	{focused}
	{label}
	{helperText}
	error={error || invalid}
	{warning}
	{icon}
>
	<Input
		on:input
		on:change
		on:keydown
		bind:focused
		on:focus
		on:blur
		error={Boolean(error)}
		warning={Boolean(warning)}
		bind:value
		bind:ref
		{borderless}
		{type}
		{debounce}
		{placeholder}
		{name}
		{required}
		{minLength}
		class={$$props.class}
		{...$$restProps}
	>
		<svelte:fragment slot="before">
			<slot name="before" />
		</svelte:fragment>
		<svelte:fragment slot="after">
			{#if isPassword && !$$slots.after}
				<InputPasswordToggle />
			{/if}
			<slot name="after" />
		</svelte:fragment>
	</Input>
	<svelte:fragment slot="popper">
		<div>
			<slot name="popper" />
		</div>
	</svelte:fragment>
</FormControl>
